// removed by extract-text-webpack-plugin
module.exports = {"container":"Confirm__container___3vsFl","outer":"Confirm__outer___3Q_j9","header":"Confirm__header___2c8GO","title":"Confirm__title___2NDsd","content":"Confirm__content___R5Edl","message":"Confirm__message___1ZyKd","footer":"Confirm__footer___3uvVu","button":"Confirm__button___ZqO_Y","cancel":"Confirm__cancel___x10D0","confirm":"Confirm__confirm___32e7a"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/views/widgets/Confirm.css
 ** module id = 710
 ** module chunks = 0
 **/